var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19957_74171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41606 17.8056C9.52606 17.8165 9.6344 17.8331 9.7469 17.8331H17.9236C18.6577 17.8331 19.3527 17.5115 19.8286 16.9514C20.3044 16.3914 20.5086 15.6506 20.3902 14.9197C20.1969 13.7297 19.0986 12.833 17.8344 12.833H11.0344L10.3511 10.333H17.8327V8.66629H9.89606L8.60523 3.94286C8.2669 2.65283 7.06356 1.82115 5.80356 2.00615C5.10023 2.10949 4.4719 2.50866 4.08106 3.10034C3.69023 3.69202 3.56856 4.42537 3.75106 5.11788L6.5294 15.3714C6.73856 16.1448 7.21773 16.7873 7.84356 17.224L7.2644 18.3815C6.8744 19.1632 6.91523 20.0715 7.3744 20.814C7.83356 21.5565 8.62773 21.9999 9.50106 21.9999H19.5011V20.3332H9.50023C9.08106 20.3332 8.86523 20.0565 8.79106 19.9382C8.71773 19.8182 8.5669 19.5023 8.7544 19.1265L9.41523 17.8048L9.41606 17.8056Z",
    fill: "#2A313C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19957_74171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.0004,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSeat);
export default __webpack_public_path__ + "static/media/blackSeat.85fedf4956ea26e4fbdbc50b61918842.svg";
export { ForwardRef as ReactComponent };